import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DisplayService {

  constructor(private http: HttpClient) { }

  displays(anbieterNr) {
    return this.http.get(environment.angebotServiceUrl+'displays/'+anbieterNr);
  }

  store(anbieterNr, displayData) {
    return this.http.post(environment.angebotServiceUrl+'displays/'+anbieterNr+'/store', displayData);
  }

  get(id) {
    return this.http.get(environment.angebotServiceUrl+'displays/get/'+id);
  } 

  update(id, data) {
    return this.http.put(environment.angebotServiceUrl+'displays/update/'+id, data);
  }

  delete(id) {
    return this.http.delete(environment.angebotServiceUrl+'displays/'+id);
  }
}
